var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapVertUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0L9 4.54545L7.7175 5.81818L5.4 3.47727V10H3.6V3.47727L1.2825 5.81818L0 4.54545L4.5 0Z",
    fill: "#6021B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapVertUp);
export default __webpack_public_path__ + "static/media/swap_vert_up.6e2bf4e94bdf1ea4e6dbdb44e99d7a17.svg";
export { ForwardRef as ReactComponent };